import { UnitOfMeasure } from '../../../../Generated/Raven-Demeter';
import { IRegionCommoditySelection } from '../../../Components/Navigation/Hooks/useRegionCommodityNavigationHook';
import { IBalanceTableChartProps } from '../../BalanceTable/BalanceTableChart';
import { IWithPageElementProps } from '../DashboardCustomizationDefinitions';

const withBalanceTableChartFromPageElement = (BalanceTableChart: React.ComponentType<IBalanceTableChartProps>): React.FC<IWithPageElementProps> => {
    const Wrapped: React.FC<IWithPageElementProps> = (props) => {
        if (!props.pageElement) {
            return <> </>;
        }

        const { demeterPageElementGuid, commodity, region, subRegion, dataFrequency, unitOfMeasure } = props.pageElement;

        const regionCommoditySelection = {
            region,
            commodity,
            unitOfMeasure,
            subRegion,
            extraParameters: '',
            dataFrequency,
        } as IRegionCommoditySelection;

        const chartProps: IBalanceTableChartProps = {
            regionCommoditySelection,
            balanceType: 'production',
            customTitle: props.customTitle,
            unitOfMeasure: unitOfMeasure ?? UnitOfMeasure.MetricTon,
            testId: `DashboardBalanceChart-${demeterPageElementGuid}`,
            dragIndicatorIcon: props.dragIndicatorIcon,
            isInDashboardEditMode: props.isInDashboardEditMode,
            maximizeMinimizeButton: props.maximizeMinimizeButton,
            maxWidthHeightRatio: props.maxWidthHeightRatio,
            handleMoreOptionsSelection: props.handleMoreOptionsSelection,
            track: { eventCategory: 'Dashboard', eventAction: 'BalanceTableChart' },
        };

        return <BalanceTableChart {...chartProps} />;
    };

    return Wrapped;
};

export default withBalanceTableChartFromPageElement;
